import React from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import { hapticEffects } from '@aytm/app/swidget/base/lib/hapticEffects'
import style from './AddToCartButton.module.scss'

interface IAddToCartButtonProps {
  quantity: number
  findability: boolean
  index: number
  limit?: number
  size: 'small' | 'big' | 'full'
  onAddToCart: (qnt: -1 | 1, index: number) => void
}

const AddToCartButton = ({ quantity, findability, index, onAddToCart, limit, size }: IAddToCartButtonProps) => {
  const { t } = useSurveyLocale()
  const add = (quantity: -1 | 1, index: number) => {
    hapticEffects.selection()
    onAddToCart(quantity, index)
  }
  return (
    <>
      {0 === quantity || findability ? (
        <button
          className={`${style.single} ${'full' === size ? style.singleFull : ''}`}
          disabled={(quantity > 0 && findability) || (limit > 0 && quantity >= limit)}
          onClick={() => {
            hapticEffects.selection()
            onAddToCart(1, index)
          }}
        >
          {t('questions', 'ec', 'ecommerce', 'addToCart')}
        </button>
      ) : (
        <div className={`${style.spin} ${style[size]}`}>
          <button className={style.sign} onClick={() => add(-1, index)}>
            {1 === quantity ? <div className={style.trashIcon} /> : <div className={style.minusIcon} />}
          </button>
          <div className={style.amount}>{quantity > 99 ? '99+' : quantity}</div>
          <button
            className={`${style.sign} ${limit && quantity >= limit ? style.disabled : ''}`}
            onClick={() => add(1, index)}
          >
            <div className={style.plusIcon} />
          </button>
        </div>
      )}
    </>
  )
}
export default AddToCartButton
